import React from "react";
import { Modal, Button } from "react-bootstrap";

interface PreviewModalProps {
  show: boolean;
  onHide: () => void;
  title?: string;
  content: React.ReactNode | null;
  error: string | null;
  centered?: boolean;
  size?: "sm" | "lg" | "xl";
  showFooter?: boolean;
  footerText?: string;
}

const PreviewModal: React.FC<PreviewModalProps> = ({
  show,
  onHide,
  title = "Preview",
  content,
  error,
  centered = false,
  size = "lg",
  showFooter = true,
  footerText = "Close"
}) => {
  return (
    <Modal centered={centered} show={show} onHide={onHide} size={size}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error ? (
          <div className="text-danger">{error}</div>
        ) : content ? (
          content
        ) : null}
      </Modal.Body>
      {showFooter && (
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            {footerText}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default PreviewModal;

